import { SpinnerOverlay, SpinnerContainer } from "./spinner.styles";

const Spinner = () => (
  <SpinnerContainer>
    <SpinnerOverlay></SpinnerOverlay>
  </SpinnerContainer>
);

export default Spinner;
